import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { slug } from 'src/utils/deburr';
import { useAppStateContext } from 'src/appState/AppState';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import { DateTime } from 'src_common/utils/time/time';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { TableSportsRowItemWrapper } from 'src/domains/sportsbook/webview/components/meetings/tableSports/TableSportsRowItem.style';
import { TableSportsSectionType } from 'src/domains/sportsbook/webview/components/meetingsAntePostAndSpecials/MeetingsGroup';

interface TableSportsRowItemType {
    eventId: EventId;
    name: string;
    sport: string;
    timeSettingsStartTime: string;
    section: TableSportsSectionType;
    handleScroll?: () => void;
}

export const TableSportsRowItem = observer('TableSportsRowItem', (props: TableSportsRowItemType) => {
    const { eventId, sport, name, timeSettingsStartTime, section, handleScroll } = props;
    const { appSportsBookState } = useAppStateContext();
    const { alternativeEventState } = appSportsBookState;
    const isAlternativeEvent = alternativeEventState.get(eventId).checkIsAlternativeEvent();

    const common = useCommon();
    const starRouter = StarRouter.get(common);
    const configState = ConfigComponents.get(common).config;

    const handleClick = (): void => {
        if (configState.isAntePostReverse && handleScroll !== undefined) {
            handleScroll();
        }

        if (isAlternativeEvent) {
            starRouter.redirectToEvent(eventId);
            return;
        }

        const isRace = sport === 'horseracing' || sport === 'greyhoundracing';

        if (isRace) {
            starRouter.redirectToRace(sport, section, { slug: slug(name), id: eventId.toOldId() });
        } else {
            console.error(
                `It is not possible to redirect to the race page because the event=${eventId.toOldId()} is not a race`
            );
        }
    };

    const dateTime = DateTime.from(timeSettingsStartTime);
    const formattedDate = dateTime?.format('DD MMM YYYY') ?? '';
    const formattedTime = dateTime?.format('HH:mm') ?? '';

    return (
        <TableSportsRowItemWrapper
            variant={configState.componentVariants.sportsbookVariant}
            formattedDate={formattedDate}
            formattedTime={formattedTime}
            handleClick={handleClick}
            label={name}
        />
    );
});
